import { Form, FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { Wrapper } from '@ahmdigital/ui';

import { useByocNavigationContext } from '../../../context/byoc-navigation-context';
import RefinePriceFormFields from '../../../../refine-price/form/refine-price-form-fields';
import StepFooterNavigation from '../../../components/step-footer-navigation';

type Props = {
  captureFormState: {
    setFormikErrors: (errors: FormikErrors<any>) => void;
    setFormikTouched: (touched: FormikTouched<any>) => void;
  };
};

const AboutYouForm = ({ captureFormState }: Props) => {
  const { errors, handleSubmit, submitCount, touched } = useFormikContext();
  const { setProductTypeFromForm } = useByocNavigationContext();
  const setFormikTouched = captureFormState?.setFormikTouched;
  const setFormikErrors = captureFormState?.setFormikErrors;

  // ErrorSummary component requires formik context values. This allows us to pass the errors and touched objects outside the LeadCaptureForm
  useEffect(() => {
    if (setFormikErrors) {
      setFormikErrors(errors);
    }
  }, [errors, setFormikErrors]);

  useEffect(() => {
    if (setFormikTouched) {
      setFormikTouched(touched);
    }
  }, [touched, setFormikTouched]);

  return (
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; onSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void; }' is missing the following properties from type 'Pick<DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>, "method" | "about" | ... 260 more ... | "onPointerLeaveCapture">': placeholder, onPointerEnterCapture, onPointerLeaveCapture
    <Form onSubmit={handleSubmit}>
      <Wrapper size="small">
        <RefinePriceFormFields
          handleChangeProductType={(productType) => setProductTypeFromForm(productType || null)}
          hasSubmitAttempt={Boolean(submitCount)}
          showPaymentFrequency={false}
        />
      </Wrapper>
      <StepFooterNavigation onNextClick={handleSubmit} />
    </Form>
  );
};

export default AboutYouForm;
